import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import {
    clientMutation,
    clientQuery,
} from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    customerId: null,
    customer: null,
    error: null,
    create: null,
    update: null
};

const route = "modules/workOrders/modals/createEditCustomer/redux/slice";

export const workOrderCreateCustomer = createAsyncThunk(
    "workOrders/workOrderCreateCustomer/createCustomer",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              mutation (
                    $name: String!
                    $ein: String
                    $customerLocation: CustomerLocationInput!
                    $customerContact: CustomerContactInput!
                    $tagIds: [Int]!
              ) {
                  data: createCustomer (
                        name: $name
                        ein: $ein
                        customerLocation: $customerLocation
                        customerContact: $customerContact
                        tagIds: $tagIds
                  ) {
                    id
                  }
              }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "createCustomer");
            return rejectWithValue(exc);
        }
    }
);

export const workOrderUpdateCustomer = createAsyncThunk(
    "workOrders/workOrderCreateCustomer/updateCustomer",
    async (payload, { rejectWithValue }) => {

        try {
            const mutation = `
              mutation (
                    $id: Int!
                    $name: String
                    $ein: String
                    $customerLocation: CustomerLocationInput
                    $customerContact: CustomerContactInput
                    $tagIds: [Int]
              ) {
                  data: updateCustomer (
                        id: $id
                        name: $name
                        ein: $ein
                        customerLocation: $customerLocation
                        customerContact: $customerContact
                        tagIds: $tagIds
                  ) {
                    id
                  }
              }
          `;

            const response = await clientMutation(
                mutation,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "updateCustomer");
            return rejectWithValue(exc);
        }
    }
);

export const workOrdersGetCustomer = createAsyncThunk(
    "workOrders/workOrderCreateCustomer/getCustomer",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                `
                    query ($id: Int!) {
                        data: getCustomer(
                            id: $id
                        ) {
                            id
                            name
                            ein
                            customerContact {
                                id
                                name
                                phone
                                email
                                notifyByPhone
                                notifyByEmail
                                countryCode
                            }
                            customerLocation {
                                id
                                name
                                address
                                contact
                                latitude
                                longitude
                                locationType
                            }
                            tagIds
                            tags {
                                id
                                label
                                color
                            }
                        }
                    }
                `,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data

        } catch (exc) {
            ExceptionManager(exc, route, "searchCustomers");
            return rejectWithValue(exc);
        }
    }
);

const workOrdersCreateEditCustomerRedux = createSlice({
    name: "workOrders/createEditCustomer",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        },
        openModalCreateEditCustomer(state, action) {
            state.open = true;
            state.customerId = action?.payload?.customerId;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //workOrderCreateCustomer
        builder.addCase(workOrderCreateCustomer.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrderCreateCustomer.fulfilled, (state, action) => {
            state.loading = false;
            state.create = action.payload;
        });
        builder.addCase(workOrderCreateCustomer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrdersGetCustomer
        builder.addCase(workOrdersGetCustomer.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrdersGetCustomer.fulfilled, (state, action) => {
            state.loading = false;
            state.customer = action.payload;
        });
        builder.addCase(workOrdersGetCustomer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        //workOrderUpdateCustomer
        builder.addCase(workOrderUpdateCustomer.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(workOrderUpdateCustomer.fulfilled, (state, action) => {
            state.loading = false;
            state.update = action.payload;
        });
        builder.addCase(workOrderUpdateCustomer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersCreateEditCustomerRedux;

// Extract and export each action creator by name
export const {
    reset,
    openModalCreateEditCustomer,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
